import { GenderEntity } from '../entities/gender-entity';

export default class State {
  items: Array<GenderEntity> = [];
}
